export enum gpsOperationLogKeys {
  longitude = 'GPS.LONGITUDE',
  latitude = 'GPS.LATITUDE'
}
